var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","data-content-area":"1200px"}},[_c('PageHeader'),_c('router-view'),_c('PagePhoneButton'),_c('PageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }